import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { AppFormattedMessage } from '../../../components/app-formatted-message/index';
import { Tag, TagVariant } from '../../../components/tag/index';
import { formatShareDelta } from '../../../utils/format-share-delta.util';

const enterAnimationClassName =
  'duration-300 animate-in fade-in-0 zoom-in-95 motion-reduce:animate-none';

/**
 * "+54,555 shares" in green / "−34,454 shares" in red, next to a pool size in the ledger. The
 * design gives the red one a 16px line on 4px padding (24px tall), the green one stays 22px. It
 * fades in with its row.
 */
export const ShareDeltaBadge: FC<{ delta: number }> = ({ delta }) => (
  <Tag
    className={twMerge(enterAnimationClassName, delta > 0 ? 'text-forest-700' : 'py-1 !leading-4')}
    title={
      <AppFormattedMessage
        id="POOL_SIZE_DELTA"
        values={{ delta: formatShareDelta(delta), count: Math.abs(delta) }}
      />
    }
    variant={delta > 0 ? TagVariant.GREEN : TagVariant.RED}
  />
);
